import './plot-downloads.scss';
import { h } from 'preact';

const { __ } = wp.i18n;

function PlotDownloads({ downloads }) {
	return (
		<div class="plot-downloads-container plot-section-container">
			<h3 class="plot-downloads-header plot-section-header">{__('Documents', 'real-estate-project')}</h3>
			{downloads.length > 0 ?
				<ul class="plot-downloads-list-container">
					{downloads.map(download => (
						<li key={download.id} class={'plot-downloads-item-container' + (download.type ? ' type-' + download.type : '')}>
							<a href={download.src} rel="noreferrer" target="_blank">{download.name || download.fileName}</a>
						</li>
					))}
				</ul> : ''}
		</div>
	);
}

export default PlotDownloads;